/**
 * @generated SignedSource<<9bf88fb5e4bba07f7f7e42c958bedf85>>
 * @relayHash 396d9a7d0dbd50c55cec1586a5cdc03d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6bdef190775fa903e65978f84114edd65263f11725156aa924a64550b3867c0e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GetTemplateInfoQuery$variables = {
  id: string;
};
export type GetTemplateInfoQuery$data = {
  readonly templateInfo: {
    readonly author: string | null | undefined;
    readonly blueprintModuleCompleteKey: string | null | undefined;
    readonly categoryIds: ReadonlyArray<string | null | undefined>;
    readonly contentBlueprintId: string | null | undefined;
    readonly darkModeIconURL: string | null | undefined;
    readonly description: string | null | undefined;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null | undefined;
    readonly iconURL: string | null | undefined;
    readonly isFavourite: boolean | null | undefined;
    readonly isNew: boolean | null | undefined;
    readonly isPromoted: boolean | null | undefined;
    readonly itemModuleCompleteKey: string | null | undefined;
    readonly link: string | null | undefined;
    readonly links: {
      readonly base: string | null | undefined;
      readonly context: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly recommendationRank: number | null | undefined;
    readonly spaceKey: string | null | undefined;
    readonly styleClass: string | null | undefined;
    readonly templateId: string | null | undefined;
    readonly templateType: string | null | undefined;
  } | null | undefined;
};
export type GetTemplateInfoQuery = {
  response: GetTemplateInfoQuery$data;
  variables: GetTemplateInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "author"
      },
      {
        "kind": "ScalarField",
        "name": "blueprintModuleCompleteKey"
      },
      {
        "kind": "ScalarField",
        "name": "categoryIds"
      },
      {
        "kind": "ScalarField",
        "name": "contentBlueprintId"
      },
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "hasGlobalBlueprintContent"
      },
      {
        "kind": "ScalarField",
        "name": "hasWizard"
      },
      {
        "kind": "ScalarField",
        "name": "iconURL"
      },
      {
        "kind": "ScalarField",
        "name": "darkModeIconURL"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ScalarField",
        "name": "isNew"
      },
      {
        "kind": "ScalarField",
        "name": "isPromoted"
      },
      {
        "kind": "ScalarField",
        "name": "itemModuleCompleteKey"
      },
      {
        "kind": "ScalarField",
        "name": "link"
      },
      {
        "concreteType": "LinksContextBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "base"
          },
          {
            "kind": "ScalarField",
            "name": "context"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "recommendationRank"
      },
      {
        "kind": "ScalarField",
        "name": "spaceKey"
      },
      {
        "kind": "ScalarField",
        "name": "styleClass"
      },
      {
        "kind": "ScalarField",
        "name": "templateId"
      },
      {
        "kind": "ScalarField",
        "name": "templateType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GetTemplateInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetTemplateInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "396d9a7d0dbd50c55cec1586a5cdc03d",
    "id": "6bdef190775fa903e65978f84114edd65263f11725156aa924a64550b3867c0e",
    "metadata": {},
    "name": "GetTemplateInfoQuery",
    "operationKind": "query",
    "text": "query GetTemplateInfoQuery($id:ID!){templateInfo(id:$id){author,blueprintModuleCompleteKey,categoryIds,contentBlueprintId,description,hasGlobalBlueprintContent,hasWizard,iconURL,darkModeIconURL,isFavourite,isNew,isPromoted,itemModuleCompleteKey,link,links{base,context},name,recommendationRank,spaceKey,styleClass,templateId,templateType}}"
  }
};
})();

(node as any).hash = "e768f9e88f51b2b2beb08ccad7f52efa";

export default node;
